import { compose } from 'redux';
import type { AppState } from '../AppState';
import type { FuelCardState } from './reducer';

const selectFuelCard = (state: AppState) => state.fuelCard;

export const selectTransactionsReport = compose((state: FuelCardState) => state.transactionsReportWebData, selectFuelCard);

export const selectFuelCardVehicles = compose((state: FuelCardState) => state.vehiclesWebData, selectFuelCard);

export const selectUpdateFuelCardVehicles = compose((state: FuelCardState) => state.updateVehiclesWebData, selectFuelCard);
